/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legal_Travel_DescriptionInputs */

const en_service_legal_travel_description = /** @type {(inputs: Service_Legal_Travel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get immediate access to legal help in urgent times of need while traveling. A global network of local professionals who are there for you just in case.`)
};

const fr_service_legal_travel_description = /** @type {(inputs: Service_Legal_Travel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenez un accès immédiat à une aide juridique en cas d'urgence pendant vos voyages. Un réseau mondial de professionnels locaux qui sont là pour vous en cas de besoin.`)
};

/**
* | output |
* | --- |
* | "Get immediate access to legal help in urgent times of need while traveling. A global network of local professionals who are there for you just in case." |
*
* @param {Service_Legal_Travel_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legal_travel_description = /** @type {((inputs?: Service_Legal_Travel_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legal_Travel_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legal_travel_description(inputs)
	return fr_service_legal_travel_description(inputs)
});